/* tslint:disable:max-line-length */
/**
 *     Import
 *     - Libraries
 */
import * as React from 'react'

export const NotificationIcon = (props) => {

    let printCurrentBell = (functionProps: any) => {
        if (functionProps.state.checked) {
            switch (functionProps.state.newNotifications) {
                case true:
                    return (
                        <svg width="24" height="27" viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <path d="M17.942 12.887c.06-.41.058-1.477.058-1.887 0-3.728-2.55-6.86-6-7.748V2c0-1.105-.895-2-2-2S8 .895 8 2v1.252C4.55 4.14 2 7.272 2 11c0 .46-.075 1.38-.004 1.858l-.002.03c0 .24-.002.48-.006.713-.063 3.677-.625 6.288-1.684 7.835-.312.456-.195 1.078.26 1.39.167.114.364.175.565.175H18.807c.2 0 .398-.06.564-.175.456-.312.572-.934.26-1.39-1.03-1.504-1.588-4.012-1.677-7.525-.008-.332-.013-.673-.013-1.023z" id="a" />
                                <circle id="b" cx="5" cy="5" r="5" />
                            </defs>
                            <g fill="none" fillRule="evenodd">
                                <path stroke="#555A77" strokeWidth="2" fill="#555A77" d="M2.994 12.918c0 .238-.002.47-.006.7-.066 3.854-.665 6.638-1.86 8.382h17.68c-1.162-1.696-1.76-4.376-1.853-8.065-.008-.34-.013-.69-.013-1.048l.01-.144c.02-.128.034-.426.042-.82.005-.272.006-.51.006-.886V11c0-3.212-2.183-5.99-5.25-6.78L11 4.027V2c0-.552-.448-1-1-1s-1 .448-1 1v2.027l-.75.193C5.182 5.01 3 7.788 3 11c0 .146-.002.222-.018.632-.005.144-.01.24-.01.337-.01.36-.006.61.013.743l.017.117-.008.088z" />
                                <path d="M7 24c0 1.657 1.343 3 3 3s3-1.343 3-3H7z" fill="#555A77" />
                                <g strokeLinecap="square">
                                    <g transform="translate(13 4)" fill="#FCA61B">
                                        <circle stroke="#F4F7FA" strokeWidth="2" cx="5" cy="5" r="6" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    )
                default:
                    return (

                        <svg width="24" height="27" viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <path d="M17.942 12.887c.06-.41.058-1.477.058-1.887 0-3.728-2.55-6.86-6-7.748V2c0-1.105-.895-2-2-2S8 .895 8 2v1.252C4.55 4.14 2 7.272 2 11c0 .46-.075 1.38-.004 1.858l-.002.03c0 .24-.002.48-.006.713-.063 3.677-.625 6.288-1.684 7.835-.312.456-.195 1.078.26 1.39.167.114.364.175.565.175H18.807c.2 0 .398-.06.564-.175.456-.312.572-.934.26-1.39-1.03-1.504-1.588-4.012-1.677-7.525-.008-.332-.013-.673-.013-1.023z" id="a" />
                            </defs>
                            <g fill="none" fillRule="evenodd">
                                <path stroke="#555A77" strokeWidth="2" fill="#555A77" d="M2.994 12.918c0 .238-.002.47-.006.7-.066 3.854-.665 6.638-1.86 8.382h17.68c-1.162-1.696-1.76-4.376-1.853-8.065-.008-.34-.013-.69-.013-1.048l.01-.144c.02-.128.034-.426.042-.82.005-.272.006-.51.006-.886V11c0-3.212-2.183-5.99-5.25-6.78L11 4.027V2c0-.552-.448-1-1-1s-1 .448-1 1v2.027l-.75.193C5.182 5.01 3 7.788 3 11c0 .146-.002.222-.018.632-.005.144-.01.24-.01.337-.01.36-.006.61.013.743l.017.117-.008.088z" />
                                <path d="M7 24c0 1.657 1.343 3 3 3s3-1.343 3-3H7z" fill="#555A77" />
                            </g>
                        </svg>
                    )
            }
        } else {
            switch (functionProps.state.newNotifications) {
                case true:
                    return (
                        <svg width="24" height="27" viewBox="0 0 24 27" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <defs>
                                <circle id="a" cx="5" cy="5" r="5" />
                            </defs>
                            <g fill="none" fillRule="evenodd">
                                <path d="M2.994 12.918c0 .238-.002.47-.006.7-.066 3.854-.665 6.638-1.86 8.382h17.68c-1.162-1.696-1.76-4.376-1.853-8.065-.008-.34-.013-.69-.013-1.048l.01-.144c.02-.128.034-.426.042-.82.005-.272.006-.51.006-.886V11c0-3.212-2.183-5.99-5.25-6.78L11 4.027V2c0-.552-.448-1-1-1s-1 .448-1 1v2.027l-.75.193C5.182 5.01 3 7.788 3 11c0 .146-.002.222-.018.632-.005.144-.01.24-.01.337-.01.36-.006.61.013.743l.017.117-.008.088z" stroke="#555A77" strokeWidth="2" />
                                <path d="M7 24c0 1.657 1.343 3 3 3s3-1.343 3-3H7z" fill="#555A77" />
                                <g strokeLinecap="square">
                                    <g transform="translate(13 4)" fill="#FCA61B">
                                        <circle stroke="#FFF" strokeWidth="2" cx="5" cy="5" r="6" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    )
                default:
                    return (
                        <svg width="24px" height="27px">
                            <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                                <g>
                                    <g>
                                        <path d="M2.99414707,12.9182659 C2.99397959,13.1556158 2.99191798,13.3890999 2.98796045,13.6187286 C2.92150868,17.4718234 2.32297915,20.2563481 1.12947293,22.0000015 L18.8070176,22 C17.6458997,20.3036671 17.0485671,17.6236647 16.9552456,13.9350671 C16.9466341,13.594456 16.9423316,13.2450084 16.9423315,12.8867201 L16.9527399,12.7428151 C16.9713674,12.6147191 16.986256,12.316508 16.9936644,11.9240514 C16.9988184,11.6510226 17.0000469,11.4137599 17.000003,11.0370574 L17,11 C17,7.78751166 14.8172463,5.00973574 11.7507415,4.22047197 L11,4.02724445 L11,2 C11,1.44771525 10.5522847,1 10,1 C9.44771525,1 9,1.44771525 9,2 L9,4.02724445 L8.24925846,4.22047197 C5.1827537,5.00973574 3,7.78751166 3,11 C3,11.1463148 2.99756292,11.2220514 2.98203982,11.6317966 C2.97659155,11.7756083 2.97325498,11.8721959 2.97058549,11.9693774 C2.96069329,12.3294988 2.96550652,12.5806669 2.98489204,12.7126754 L3.00215524,12.8302317 L2.99414708,12.9182658 Z" id="Combined-Shape" stroke="#555A77" strokeWidth="2" />
                                        <path d="M7,24 C7,25.6568542 8.34314575,27 10,27 C11.6568542,27 13,25.6568542 13,24 L7,24 Z" id="Oval-8" fill="#555A77" />
                                    </g>
                                </g>
                            </g>
                        </svg>
                    )
            }
        }

    }

    return printCurrentBell(props)
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/images/icons/Notification/Notification.tsx